import { useEffect, useState } from "react";
import { Accordion, OverlayTrigger, Popover } from "react-bootstrap";
import { LoadingScreen, UserHover } from "Components";
import { newAuthService } from "Service/Axios";
import { APPLICATION_TIMELINE_URL } from "Constant/api";
import { formatDateWithFullMonthTime, getFirstLetterOfName } from "Utils";

export const Timeline = ({ gid }) => {
  const [loading, setLoading] = useState(false);
  const [allTimelines, setAllTimelines] = useState([]);

  // Listing
  const getTimelinesList = async () => {
    const payload = {
      gid,
    };
    setLoading(true);
    const response = await newAuthService(
      APPLICATION_TIMELINE_URL,
      "POST",
      payload
    );
    if (response.status) {
      setAllTimelines(response.data);
      setLoading(false);
    } else {
      setAllTimelines([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    getTimelinesList();
  }, [gid]);

  return (
    <div className="applicant-status-body timeline-tab px-3 py-3 bg-transparent overflow-y-auto">
      <div className="timeline-body">
        <div className="custom-card">
          <div className="card-body">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <LoadingScreen />
              </div>
            ) : (
              <Accordion alwaysOpen className="timeline-list-item">
                {allTimelines &&
                  allTimelines.length > 0 &&
                  allTimelines.map((timeline, index) => (
                    <Accordion.Item
                      eventKey={index}
                      className={`timeline-item timeline-${timeline.status}`}
                      key={index.toString()}
                    >
                      <div className="acrodion-headerbar">
                        <button className="btn">{timeline.stage}</button>
                        <Accordion.Header></Accordion.Header>
                      </div>
                      <Accordion.Body className="bg-transparent rounded-2 p-5 border-0">
                        <span className="day-box">
                          {timeline.duration} days
                        </span>
                        <ul className="timeline-status-list">
                          {timeline.stageDetails &&
                            timeline.stageDetails.length > 0 &&
                            timeline.stageDetails.map((stage) => (
                              <li key={stage.gid}>
                                {/* <div className="hover-effect">
                                <div className="img-box cursor-pointer">
                                  {stage.photoURL ? (
                                    <img
                                      src={stage.photoURL}
                                      alt={`${stage.firstName}${stage.lastName}`}
                                    />
                                  ) : (
                                    getFirstLetterOfName(stage)
                                  )}
                                </div>
                                <UserHover user={stage} />
                              </div> */}
                                <div className="img-box cursor-pointer">
                                  <OverlayTrigger
                                    placement="right"
                                    overlay={
                                      <Popover className="max-w-unset">
                                        <UserHover user={stage} />
                                      </Popover>
                                    }
                                  >
                                    {stage.photoURL ? (
                                      <img
                                        src={stage.photoURL}
                                        alt={
                                          "${stage.firstName} ${stage.lastName}"
                                        }
                                        className="w-100 h-100 object-fit-cover"
                                      />
                                    ) : (
                                      getFirstLetterOfName(stage)
                                    )}

                                    {/* <div className="avatar-short-dtls ms-2">
                                      <h6 className="h6 mb-0 text-nowrap text-slate-500">
                                        {stage.firstName} {stage.lastName}
                                      </h6>
                                    </div> */}
                                  </OverlayTrigger>
                                </div>
                                <div className="timeline-status-box">
                                  <h4 className="timeline-status">
                                    <strong>
                                      {stage.firstName} {stage.lastName}
                                    </strong>{" "}
                                    {stage.name} <strong>{stage.text}</strong>
                                  </h4>
                                  <div className="status-post-time">
                                    {/* Apr 20, 2023 at 04:35 PM */}
                                    {stage.date &&
                                      formatDateWithFullMonthTime(stage.date)}
                                  </div>
                                </div>
                              </li>
                            ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
              </Accordion>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
